import { render, staticRenderFns } from "./TitleScreen.vue?vue&type=template&id=a7f5195a&scoped=true&"
import script from "./TitleScreen.vue?vue&type=script&lang=js&"
export * from "./TitleScreen.vue?vue&type=script&lang=js&"
import style0 from "./TitleScreen.vue?vue&type=style&index=0&id=a7f5195a&scoped=true&lang=css&"
import style1 from "./TitleScreen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f5195a",
  null
  
)

export default component.exports